import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import API from "../../api/Createapi";
import './Registerpage.css';
import '../login/Loginpage.css';

import {
    FaUser,
    FaEnvelope,
    FaLock,
    FaPhone,
    FaCity,
    FaMapMarkerAlt,
    FaHashtag,
    FaEye,
    FaEyeSlash,
    FaUserPlus,
    FaBolt,
    FaShieldAlt,
    FaHeadset,
    FaCheckCircle,
    FaExclamationCircle,
    FaSignInAlt
} from 'react-icons/fa';

import {
    toast,
    ToastContainer
} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import Loader from '../Loader';
import logo from "../../Assets/ritu.png";


function Registerpage() {

    const navigate = useNavigate();


    /* =====================================================
       LOADING
    ===================================================== */

    const [loading, setLoading] = useState(false);


    /* =====================================================
       REGISTRATION STATUS

       checking
       valid
       completed
       expired
       invalid
       error
    ===================================================== */

    const [registrationStatus, setRegistrationStatus] =
        useState("checking");


    /* =====================================================
       REGISTRATION TOKEN
    ===================================================== */

    const [registrationToken, setRegistrationToken] =
        useState("");


    /* =====================================================
       FORM DATA
    ===================================================== */

    const [form, setForm] = useState({

        fullname: "",
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        mobile: "",
        city: "",
        address: "",
        pincode: ""

    });


    /* =====================================================
       PASSWORD VISIBILITY
    ===================================================== */

    const [showPassword, setShowPassword] =
        useState(false);

    const [showConfirmPassword, setShowConfirmPassword] =
        useState(false);


    /* =====================================================
       TERMS
    ===================================================== */

    const [agreeTerms, setAgreeTerms] =
        useState(false);


    /* =====================================================
       CHECK REGISTRATION STATUS

       URL:
       /register?token=xxxxxxxx
    ===================================================== */

    useEffect(() => {

        const checkRegistrationStatus = async () => {

            try {

                const params =
                    new URLSearchParams(
                        window.location.search
                    );

                const token =
                    params.get("token");


                /* -----------------------------------------
                   TOKEN MISSING
                ----------------------------------------- */

                if (!token) {

                    console.error(
                        "Registration token missing"
                    );

                    setRegistrationStatus("invalid");

                    toast.error(
                        "Registration link is invalid or missing."
                    );

                    return;
                }


                /* -----------------------------------------
                   SAVE TOKEN
                ----------------------------------------- */

                setRegistrationToken(token);


                console.log(
                    "Registration token found"
                );


                /* -----------------------------------------
                   CHECK TOKEN STATUS

                   IMPORTANT:
                   Using existing API instance.
                   No axios import required.
                   No API_URL required.
                ----------------------------------------- */

                const response = await API.get(
                    `/register.php?token=${encodeURIComponent(token)}`
                );


                console.log(
                    "Registration status response:",
                    response.data
                );


                /* -----------------------------------------
                   COMPLETED
                ----------------------------------------- */

                if (
                    response.data.status ===
                    "completed"
                ) {

                    setRegistrationStatus(
                        "completed"
                    );

                    return;
                }


                /* -----------------------------------------
                   VALID
                ----------------------------------------- */

                if (
                    response.data.status ===
                    "valid"
                ) {

                    setRegistrationStatus(
                        "valid"
                    );

                    /*
                       Optional:
                       Fill approved user details
                       from request_users.
                    */

                    setForm(prevForm => ({

                        ...prevForm,

                        fullname:
                            response.data.name ||
                            prevForm.fullname,

                        email:
                            response.data.email ||
                            prevForm.email,

                        mobile:
                            response.data.mobile ||
                            prevForm.mobile

                    }));

                    return;
                }


                /* -----------------------------------------
                   EXPIRED
                ----------------------------------------- */

                if (
                    response.data.status ===
                    "expired"
                ) {

                    setRegistrationStatus(
                        "expired"
                    );

                    return;
                }


                /* -----------------------------------------
                   NOT APPROVED
                ----------------------------------------- */

                if (
                    response.data.status ===
                    "not_approved"
                ) {

                    setRegistrationStatus(
                        "not_approved"
                    );

                    return;
                }


                /* -----------------------------------------
                   INVALID TOKEN
                ----------------------------------------- */

                if (
                    response.data.status ===
                    "invalid_token"
                ) {

                    setRegistrationStatus(
                        "invalid"
                    );

                    return;
                }


                /* -----------------------------------------
                   UNKNOWN RESPONSE
                ----------------------------------------- */

                setRegistrationStatus(
                    "invalid"
                );


            } catch (error) {

                console.error(
                    "Registration status error:",
                    error
                );


                /*
                   If backend returns JSON error
                */

                if (
                    error.response &&
                    error.response.data
                ) {

                    console.error(
                        "Server response:",
                        error.response.data
                    );

                }


                setRegistrationStatus(
                    "error"
                );

            }

        };


        checkRegistrationStatus();

    }, []);


    /* =====================================================
       HANDLE INPUT CHANGE
    ===================================================== */

    const handleChange = (e) => {

        const {
            name,
            value
        } = e.target;


        setForm(prevForm => ({

            ...prevForm,

            [name]: value

        }));

    };


    /* =====================================================
       HANDLE REGISTRATION
    ===================================================== */

    const handleSubmit = async (e) => {

        e.preventDefault();


        /* =================================================
           CHECK REGISTRATION STATUS
        ================================================= */

        if (
            registrationStatus !== "valid"
        ) {

            toast.error(
                "This registration link is not valid."
            );

            return;
        }


        /* =================================================
           TOKEN VALIDATION
        ================================================= */

        if (!registrationToken) {

            toast.error(
                "Invalid or expired registration link."
            );

            return;
        }


        /* =================================================
           TERMS VALIDATION
        ================================================= */

        if (!agreeTerms) {

            toast.error(
                "Please agree to the Terms & Conditions."
            );

            return;
        }


        /* =================================================
           PASSWORD VALIDATION
        ================================================= */

        if (
            form.password !==
            form.confirmPassword
        ) {

            toast.error(
                "Passwords do not match!"
            );

            return;
        }


        if (
            form.password.length < 6
        ) {

            toast.error(
                "Password must be at least 6 characters."
            );

            return;
        }


        /* =================================================
           START LOADING
        ================================================= */

        setLoading(true);


        try {

            /* =================================================
               REGISTRATION PAYLOAD
            ================================================= */

            const registrationData = {

                fullname:
                    form.fullname.trim(),

                username:
                    form.username.trim(),

                email:
                    form.email.trim(),

                password:
                    form.password,

                mobile:
                    form.mobile.trim(),

                city:
                    form.city.trim(),

                address:
                    form.address.trim(),

                pincode:
                    form.pincode.trim(),

                token:
                    registrationToken

            };


            console.log(
                "Registration request:",
                {
                    ...registrationData,
                    password: "******"
                }
            );


            /* =================================================
               CALL REGISTER PHP
            ================================================= */

            const res = await API.post(
                "/register.php",
                registrationData
            );


            console.log(
                "Registration response:",
                res.data
            );


            /* =================================================
               SUCCESS
            ================================================= */

            if (
                res.data.status ===
                "success"
            ) {

                /*
                   IMPORTANT:

                   Don't immediately navigate to login.

                   First show Registration Completed.
                */

                setRegistrationStatus(
                    "completed"
                );


                toast.success(
                    "Registration completed successfully!"
                );


                /*
                   Clear password fields.
                */

                setForm(prevForm => ({

                    ...prevForm,

                    password: "",
                    confirmPassword: ""

                }));


                return;
            }


            /* =================================================
               EXISTING USER
            ================================================= */

            if (
                res.data.status ===
                "exists"
            ) {

                toast.error(
                    res.data.message ||
                    "Username, email or mobile is already registered!"
                );

                return;
            }


            /* =================================================
               INVALID TOKEN
            ================================================= */

            if (
                res.data.status ===
                "invalid_token"
            ) {

                setRegistrationStatus(
                    "invalid"
                );


                toast.error(
                    res.data.message ||
                    "Registration link is invalid or expired."
                );

                return;
            }


            /* =================================================
               ALREADY COMPLETED
            ================================================= */

            if (
                res.data.status ===
                "completed"
            ) {

                setRegistrationStatus(
                    "completed"
                );


                toast.info(
                    "Registration has already been completed."
                );

                return;
            }


            /* =================================================
               OTHER ERROR
            ================================================= */

            toast.error(
                res.data.message ||
                "Registration failed. Please try again."
            );


        } catch (err) {

            console.error(
                "Registration error:",
                err
            );


            /* =================================================
               SERVER ERROR
            ================================================= */

            if (
                err.response &&
                err.response.data &&
                err.response.data.message
            ) {

                toast.error(
                    err.response.data.message
                );

            } else {

                toast.error(
                    "Server connection error. Please try again."
                );

            }

        } finally {

            setLoading(false);

        }

    };


    /* =====================================================
       CHECKING SCREEN
    ===================================================== */

    if (
        registrationStatus ===
        "checking"
    ) {

        return (

            <div className="auth-page-wrapper">

                <Loader />

                <div
                    style={{
                        textAlign: "center",
                        marginTop: "100px",
                        color: "#334155"
                    }}
                >

                    <h2>
                        Checking Registration Link...
                    </h2>

                    <p>
                        Please wait while we verify your
                        registration link.
                    </p>

                </div>


                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    theme="colored"
                />

            </div>

        );

    }


    /* =====================================================
       COMPLETED SCREEN
    ===================================================== */

    if (
        registrationStatus ===
        "completed"
    ) {

        return (

            <div className="auth-page-wrapper">


                <div
                    className="auth-card"
                    style={{
                        maxWidth: "650px",
                        minHeight: "450px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >

                    <div
                        style={{
                            width: "100%",
                            textAlign: "center",
                            padding: "50px 35px"
                        }}
                    >


                        {/* SUCCESS ICON */}

                        <div
                            style={{
                                width: "90px",
                                height: "90px",
                                borderRadius: "50%",
                                background:
                                    "#ecfdf5",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin:
                                    "0 auto 25px"
                            }}
                        >

                            <FaCheckCircle
                                style={{
                                    fontSize: "65px",
                                    color: "#16a34a"
                                }}
                            />

                        </div>


                        {/* TITLE */}

                        <h2
                            style={{
                                fontSize: "30px",
                                color: "#0f172a",
                                marginBottom: "12px"
                            }}
                        >

                            Registration Completed

                        </h2>


                        {/* DESCRIPTION */}

                        <p
                            style={{
                                fontSize: "16px",
                                color: "#64748b",
                                lineHeight: "1.7",
                                maxWidth: "500px",
                                margin:
                                    "0 auto 30px"
                            }}
                        >

                            Your RiTU Broad Band account
                            has been created successfully.

                            <br />

                            You can now login to your
                            account.

                        </p>


                        {/* LOGIN BUTTON */}

                        <button
                            type="button"
                            onClick={() =>
                                navigate("/login")
                            }
                            style={{
                                border: "none",
                                borderRadius: "8px",
                                padding:
                                    "13px 28px",
                                background:
                                    "#0b72b9",
                                color: "#ffffff",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px"
                            }}
                        >

                            <FaSignInAlt />

                            Go to Login

                        </button>


                    </div>

                </div>


                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    theme="colored"
                />

            </div>

        );

    }


    /* =====================================================
       EXPIRED SCREEN
    ===================================================== */

    if (
        registrationStatus ===
        "expired"
    ) {

        return (

            <div className="auth-page-wrapper">

                <div
                    className="auth-card"
                    style={{
                        maxWidth: "650px",
                        minHeight: "400px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >

                    <div
                        style={{
                            width: "100%",
                            textAlign: "center",
                            padding: "50px 35px"
                        }}
                    >

                        <div
                            style={{
                                width: "90px",
                                height: "90px",
                                borderRadius: "50%",
                                background:
                                    "#fff7ed",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin:
                                    "0 auto 25px"
                            }}
                        >

                            <FaExclamationCircle
                                style={{
                                    fontSize: "65px",
                                    color: "#f97316"
                                }}
                            />

                        </div>


                        <h2
                            style={{
                                fontSize: "30px",
                                color: "#0f172a",
                                marginBottom: "12px"
                            }}
                        >

                            Registration Link Expired

                        </h2>


                        <p
                            style={{
                                color: "#64748b",
                                fontSize: "16px",
                                lineHeight: "1.7",
                                marginBottom: "30px"
                            }}
                        >

                            This registration link has
                            expired.

                            <br />

                            Please contact the administrator
                            and request a new registration link.

                        </p>


                        <button
                            type="button"
                            onClick={() =>
                                navigate("/login")
                            }
                            style={{
                                border: "none",
                                borderRadius: "8px",
                                padding:
                                    "13px 28px",
                                background:
                                    "#0b72b9",
                                color: "#ffffff",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >

                            Go to Login

                        </button>

                    </div>

                </div>


                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    theme="colored"
                />

            </div>

        );

    }


    /* =====================================================
       INVALID / ERROR / NOT APPROVED
    ===================================================== */

    if (
        registrationStatus === "invalid" ||
        registrationStatus === "error" ||
        registrationStatus === "not_approved"
    ) {

        let title =
            "Invalid Registration Link";

        let message =
            "This registration link is invalid or unavailable.";

        if (
            registrationStatus ===
            "not_approved"
        ) {

            title =
                "Request Not Approved";

            message =
                "Your registration request has not been approved yet.";

        }


        if (
            registrationStatus ===
            "error"
        ) {

            title =
                "Unable to Verify Link";

            message =
                "We could not verify your registration link. Please try again later.";

        }


        return (

            <div className="auth-page-wrapper">

                <div
                    className="auth-card"
                    style={{
                        maxWidth: "650px",
                        minHeight: "400px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >

                    <div
                        style={{
                            width: "100%",
                            textAlign: "center",
                            padding: "50px 35px"
                        }}
                    >

                        <div
                            style={{
                                width: "90px",
                                height: "90px",
                                borderRadius: "50%",
                                background:
                                    "#fef2f2",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin:
                                    "0 auto 25px"
                            }}
                        >

                            <FaExclamationCircle
                                style={{
                                    fontSize: "65px",
                                    color: "#dc2626"
                                }}
                            />

                        </div>


                        <h2
                            style={{
                                fontSize: "30px",
                                color: "#0f172a",
                                marginBottom: "12px"
                            }}
                        >

                            {title}

                        </h2>


                        <p
                            style={{
                                color: "#64748b",
                                fontSize: "16px",
                                lineHeight: "1.7",
                                marginBottom: "30px"
                            }}
                        >

                            {message}

                        </p>


                        <button
                            type="button"
                            onClick={() =>
                                navigate("/login")
                            }
                            style={{
                                border: "none",
                                borderRadius: "8px",
                                padding:
                                    "13px 28px",
                                background:
                                    "#0b72b9",
                                color: "#ffffff",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >

                            Go to Login

                        </button>

                    </div>

                </div>


                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    theme="colored"
                />

            </div>

        );

    }


    /* =====================================================
       NORMAL REGISTRATION FORM
       ONLY WHEN TOKEN IS VALID
    ===================================================== */

    return (

        <div className="auth-page-wrapper">

            {loading && <Loader />}


            <div className="auth-card register-card-wide">


                {/* =================================================
                   LEFT SIDE
                ================================================= */}

                <div className="auth-hero-banner">

                    <div
                        className="auth-hero-glow auth-glow-1"
                    />

                    <div
                        className="auth-hero-glow auth-glow-2"
                    />


                    <div className="auth-hero-content">


                        <div className="auth-brand-text-logo">

                            RiTU{" "}

                            <span>
                                BROAD BAND
                            </span>

                        </div>


                        <h2 className="auth-hero-title">

                            Join Ritu Broad Band

                        </h2>


                        <p className="auth-hero-desc">

                            Create your account to access
                            ultra-fast fiber plans, seamless
                            online payments, and instant
                            account management.

                        </p>


                        <div className="auth-features-list">


                            <div className="auth-feature-item">

                                <div
                                    className="auth-feature-icon"
                                >

                                    <FaBolt />

                                </div>

                                <span>

                                    Blazing Fast Gigabit Speeds

                                </span>

                            </div>


                            <div className="auth-feature-item">

                                <div
                                    className="auth-feature-icon"
                                >

                                    <FaShieldAlt />

                                </div>

                                <span>

                                    Zero Downtime Fiber Connection

                                </span>

                            </div>


                            <div className="auth-feature-item">

                                <div
                                    className="auth-feature-icon"
                                >

                                    <FaHeadset />

                                </div>

                                <span>

                                    Instant Customer Support

                                </span>

                            </div>


                        </div>

                    </div>

                </div>


                {/* =================================================
                   RIGHT SIDE
                ================================================= */}

                <div className="auth-form-panel">


                    <div className="auth-header">

                        <h2>
                            Create Account
                        </h2>

                        <p>

                            Fill in your details to get started
                            with Ritu Broad Band

                        </p>

                    </div>


                    <form
                        onSubmit={handleSubmit}
                        className="auth-form"
                    >


                        {/* =================================================
                           FULL NAME + USERNAME
                        ================================================= */}

                        <div className="auth-grid-row">


                            <div className="input-group">

                                <label htmlFor="fullname">

                                    Full Name *

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaUser />

                                    </span>


                                    <input
                                        id="fullname"
                                        name="fullname"
                                        type="text"
                                        placeholder="Full Name"
                                        value={form.fullname}
                                        onChange={handleChange}
                                        required
                                        style={{
                                            textTransform:
                                                "capitalize"
                                        }}
                                    />

                                </div>

                            </div>


                            <div className="input-group">

                                <label htmlFor="username">

                                    Username *

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaUser />

                                    </span>


                                    <input
                                        id="username"
                                        name="username"
                                        type="text"
                                        placeholder="Username"
                                        value={form.username}
                                        onChange={handleChange}
                                        required
                                    />

                                </div>

                            </div>


                        </div>


                        {/* =================================================
                           EMAIL
                        ================================================= */}

                        <div className="input-group">

                            <label htmlFor="email">

                                Email Address *

                            </label>


                            <div className="input-field-wrapper">

                                <span className="input-field-icon">

                                    <FaEnvelope />

                                </span>


                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    placeholder="name@example.com"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                        </div>


                        {/* =================================================
                           PASSWORD
                        ================================================= */}

                        <div className="auth-grid-row">


                            <div className="input-group">

                                <label htmlFor="password">

                                    Password *

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaLock />

                                    </span>


                                    <input
                                        id="password"
                                        name="password"
                                        type={
                                            showPassword
                                                ? "text"
                                                : "password"
                                        }
                                        placeholder="Min 6 characters"
                                        value={form.password}
                                        onChange={handleChange}
                                        required
                                    />


                                    <span
                                        className="password-toggle-btn"
                                        onClick={() =>
                                            setShowPassword(
                                                !showPassword
                                            )
                                        }
                                    >

                                        {
                                            showPassword
                                                ?
                                                <FaEyeSlash />
                                                :
                                                <FaEye />
                                        }

                                    </span>

                                </div>

                            </div>


                            <div className="input-group">

                                <label htmlFor="confirmPassword">

                                    Confirm Password *

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaLock />

                                    </span>


                                    <input
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        type={
                                            showConfirmPassword
                                                ? "text"
                                                : "password"
                                        }
                                        placeholder="Repeat password"
                                        value={
                                            form.confirmPassword
                                        }
                                        onChange={
                                            handleChange
                                        }
                                        required
                                    />


                                    <span
                                        className="password-toggle-btn"
                                        onClick={() =>
                                            setShowConfirmPassword(
                                                !showConfirmPassword
                                            )
                                        }
                                    >

                                        {
                                            showConfirmPassword
                                                ?
                                                <FaEyeSlash />
                                                :
                                                <FaEye />
                                        }

                                    </span>

                                </div>

                            </div>


                        </div>


                        {/* =================================================
                           MOBILE + CITY
                        ================================================= */}

                        <div className="auth-grid-row">


                            <div className="input-group">

                                <label htmlFor="mobile">

                                    Mobile Number *

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaPhone />

                                    </span>


                                    <input
                                        id="mobile"
                                        name="mobile"
                                        type="tel"
                                        placeholder="10-digit mobile"
                                        value={form.mobile}
                                        onChange={handleChange}
                                        required
                                    />

                                </div>

                            </div>


                            <div className="input-group">

                                <label htmlFor="city">

                                    City

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaCity />

                                    </span>


                                    <input
                                        id="city"
                                        name="city"
                                        type="text"
                                        placeholder="City"
                                        value={form.city}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                        </div>


                        {/* =================================================
                           ADDRESS + PINCODE
                        ================================================= */}

                        <div className="auth-grid-row">


                            <div className="input-group">

                                <label htmlFor="address">

                                    Address

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaMapMarkerAlt />

                                    </span>


                                    <input
                                        id="address"
                                        name="address"
                                        type="text"
                                        placeholder="Street address"
                                        value={form.address}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                            <div className="input-group">

                                <label htmlFor="pincode">

                                    Pincode

                                </label>


                                <div className="input-field-wrapper">

                                    <span className="input-field-icon">

                                        <FaHashtag />

                                    </span>


                                    <input
                                        id="pincode"
                                        name="pincode"
                                        type="text"
                                        placeholder="6-digit pincode"
                                        value={form.pincode}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                        </div>


                        {/* =================================================
                           TERMS
                        ================================================= */}

                        <div
                            className="terms-checkbox-group"
                            style={{
                                margin:
                                    "14px 0 6px",
                                display:
                                    "flex",
                                alignItems:
                                    "center",
                                gap: "8px",
                                fontSize:
                                    "0.85rem",
                                color:
                                    "#475569"
                            }}
                        >

                            <input
                                type="checkbox"
                                id="agreeTermsPage"
                                checked={agreeTerms}
                                onChange={(e) =>
                                    setAgreeTerms(
                                        e.target.checked
                                    )
                                }
                                style={{
                                    width: "17px",
                                    height: "17px",
                                    cursor: "pointer",
                                    accentColor:
                                        "#0B72B9"
                                }}
                            />


                            <label
                                htmlFor="agreeTermsPage"
                                style={{
                                    cursor:
                                        "pointer",
                                    userSelect:
                                        "none"
                                }}
                            >

                                I agree to the{" "}

                                <a
                                    href="/terms-and-conditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color:
                                            "#0B72B9",
                                        fontWeight:
                                            "600",
                                        textDecoration:
                                            "underline"
                                    }}
                                >

                                    Terms &amp; Conditions

                                </a>

                            </label>

                        </div>


                        {/* =================================================
                           REGISTER BUTTON
                        ================================================= */}

                        <button
                            type="submit"
                            className="auth-submit-btn"
                            disabled={
                                loading ||
                                !agreeTerms ||
                                !registrationToken ||
                                registrationStatus !== "valid"
                            }
                        >

                            {
                                loading
                                    ?
                                    "Registering Account..."
                                    :
                                    (
                                        <>
                                            <FaUserPlus />

                                            Register Now
                                        </>
                                    )
                            }

                        </button>


                    </form>


                    {/* =================================================
                       FOOTER
                    ================================================= */}

                    <div className="auth-footer-prompt">

                        <p>

                            Already have an account?{" "}

                            <span
                                className="auth-action-link"
                                onClick={() =>
                                    navigate("/login")
                                }
                            >

                                Sign In Here

                            </span>

                        </p>

                    </div>


                </div>

            </div>


            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

        </div>

    );

}


export default Registerpage;